import React, { useState } from 'react';
import './TimesheetPage.css';

import profilePic1 from '../assets/mayazure.jpeg';
import profilePic2 from '../assets/DBdemo1.png';
import profilePic3 from '../assets/ac.png';
import profilePic4 from '../assets/profile.png';
import profilePic5 from '../assets/nb.jpg';
import profilePic6 from '../assets/profile.png';

const RosterPage = () => {
  const [department, setDepartment] = useState('');
  const [selectedImage, setSelectedImage] = useState('');
  const month = '2025-05'; // Fixed to May 2025

  // Mapping departments to specific images
  const departmentImages = {
    "Azure Production Support": profilePic1,
    "DBA": profilePic2,
    "Help Desk": profilePic3,
    "MSBI": profilePic4,
    "Full-Stack": profilePic5,
    "Human Resource(HR)": profilePic6,
    "Production Support": profilePic1,  // You can change this to another image if required
  };

  const handleSearch = () => {
    if (!department) {
      alert('Please select a department.');
      return;
    }

    // Set the selected image based on the department
    setSelectedImage(departmentImages[department]);
  };

  return (
    <div className="roster-page">
      <h2>Roster for May 2025</h2>

      <div className="filters">
        <label>
          Select Department:
          <select
            value={department}
            onChange={(e) => setDepartment(e.target.value)}
          >
            <option value="">-- Select --</option>
            <option value="Azure Production Support">Azure Production Support</option>
            <option value="DBA">DBA</option>
            <option value="Help Desk">Help Desk</option>
            <option value="MSBI">MSBI</option>
            <option value="Full-Stack">Full-Stack</option>
            <option value="Human Resource(HR)">Human Resource (HR)</option>
            <option value="Production Support">Production Support</option>
          </select>
        </label>
        <button onClick={handleSearch}>Search</button>
      </div>

      <div className="profile-grid">
        {selectedImage && (
          <div className="profile-item">
            <img src={selectedImage} alt="Selected Profile" />
          </div>
        )}
      </div>
    </div>
  );
};

export default RosterPage;
